/**
 * Combine all actions in this file and export the combined actions.
 */
// Add any additional actions here
import * as apiActions from './apiActions';

const actions = {
	...apiActions,
};

export default actions;
